import CreatePa from "./CreatePa";
export default CreatePa;